import { render, staticRenderFns } from "./FormVigencia.vue?vue&type=template&id=53c470f1"
import script from "./FormVigencia.vue?vue&type=script&lang=js"
export * from "./FormVigencia.vue?vue&type=script&lang=js"
import style0 from "./FormVigencia.vue?vue&type=style&index=0&id=53c470f1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports